var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgError = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6753 11.5814L10.017 1.16455C9.58989 0.44561 8.83564 0.0162354 7.99939 0.0162354C7.16314 0.0162354 6.40889 0.44561 5.98183 1.16455L5.97725 1.1728L5.97267 1.18105L0.333169 11.5649C-0.103049 12.299 -0.111299 13.1806 0.310701 13.9229C0.73367 14.6657 1.49567 15.1088 2.35026 15.1088H13.6173C14.4719 15.1088 15.2652 14.6657 15.6881 13.9229C16.1101 13.1806 16.1019 12.299 15.6753 11.5814ZM7.06095 4.78589C7.06095 4.26758 7.48111 3.84745 7.99939 3.84745C8.5177 3.84745 8.93783 4.26761 8.93783 4.78589V8.53967C8.93783 9.05792 8.51767 9.47811 7.99939 9.47811C7.48111 9.47811 7.06095 9.05789 7.06095 8.53967V4.78589ZM6.5917 11.8242C6.5917 12.6005 7.22317 13.2319 7.99939 13.2319C8.77564 13.2319 9.40708 12.6005 9.40704 11.8242C9.40704 11.048 8.77561 10.4166 7.99939 10.4166C7.22314 10.4166 6.5917 11.048 6.5917 11.8242Z",
    fill: "#CC6666"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.e8697e15.svg";
export { ForwardRef as ReactComponent };